<template>
  <basic-modal v-bind="modal" :cssAfectsWidth="false" ref="basicModal">
    <div class="dialog-modal">
      <template v-if="hasHeader">
        <div class="dialog-modal__header">
          {{header}}
        </div>
      </template>

      <div class="dialog-modal__content">
        <template v-if="message">
          {{message}}
        </template>
        <slot v-else name="content"></slot>
      </div>
      <template v-if="hasFooter">
        <div class="dialog-modal__footer">
          <hr>
          <template v-if="!hasFooterSlot">
            <div class="dialog-modal__footer__buttons">
              <action-button
                @click.native="clickYes"
                color="success"
                label="yesLabel"
              >
              </action-button>
              <action-button
                @click.native="clickNo"
                label="noLabel"
                color="secondary"
              >
              </action-button>
            </div>
          </template>
          <slot v-else name="footer"></slot>
        </div>
      </template>
    </div>
  </basic-modal>
</template>

<script>
import BasicModal from './BasicModal'
import ActionButton from '@/components/common/actionButton/ActionButton'
/**
 * we need to include the 3 sections here
 * 1. we need the header, so lets just do that now
 */
export default {
  components: {
    BasicModal,
    ActionButton
  },
  props: {
    modal: {  // same props as Basic Modal
      type: Object,
      default: () => { return {} }
    },
    header: {
      type: String,
      default: null
    },
    message: {
      type: String,
      default: undefined
    },
    hasFooter: {
      type: Boolean,
      default: true
    },
    yesLabel: {
      type: String,
      default: 'YES'
    },
    noLabel: {
      type: String,
      default: 'NO'
    }
  },
  computed: {
    bm () {
      return this.$refs.basicModal
    },
    hasFooterSlot () {
      return this.$slots.footer
    },
    hasHeader () {
      return this.header
    }
  },
  methods: {
    open () {
      this.bm.open()
    },
    close () {
      this.bm.close()
    },
    clickYes () {
      this.$emit('yes')
      this.close()
    },
    clickNo () {
      this.$emit('no')
      this.close()
    }
  }
}
</script>

<style lang="scss">
$paddingContent: 15px;
$paddingFooter: 50px;

.dialog-modal {
  &__header {
    background-color: color(grays, light);
    color: color(blue-grey, very-dark);
    text-transform: uppercase;
    font-size: rem(16);
    font-weight: bold;
    text-align: center;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  &__content {
    background-color: color(grays, dark);
    padding: 15px 50px 15px 50px;
    color: white;
  }
  &__footer {
    min-height: 60px;
    background-color: color(grays, dark);
    padding: 0px $paddingFooter 0px $paddingFooter;

    &__buttons {
      display: flex;
      flex-direction: row-reverse;
      margin-top: 15px;
      margin-right: 30px;

      button {
        margin-left: 10px;
      }
    }
  }
  hr {
    margin-top:0;
    margin-bottom:0;
    margin-left: 30px;
    margin-right: 30px;
    border:0;
    height:1px;
    background-color:rgb(144, 144, 144);
  }
}
</style>



// WEBPACK FOOTER //
// DialogModal.vue?80664c0c